export const PolicyholderMask = () => {
  const nameChars = /[А-Яа-яЁёІіЇїЄєʼa-zA-Z\s'-]/g;
  const digitChars = /[0-9]/g;

  const filterChars = (value, regex) =>
    String(value).match(regex)?.join('') ?? '';

  const nameMask = (value) => {
    if (!value) return value;
    return filterChars(value, nameChars);
  };

  const taxNumberMask = (value) => {
    if (!value) return value;
    return filterChars(value, digitChars);
  };

  return { nameMask, taxNumberMask };
};
